import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v2/customers/get/by-id.ts
var by_id_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var SubscriptionDetailsSchema = z.object({
	additionalStreamMinutes: z.number(),
	additionalViewerMinutes: z.number(),
	aiVideosPerMonth: z.number(),
	concurrentRtmpStreams: z.number(),
	contentLibraryTrialCancelled: z.boolean(),
	contentLibraryTrialEndTimestamp: z.string(),
	contentLibraryTrialPlanId: z.string(),
	contentLibraryTrialStatus: z.string(),
	subtitlesHoursPerMonth: z.number()
});
var UsageSummarySchema = z.object({
	concurrentWebBroadcasts: z.number(),
	enterpriseLicenses: z.number(),
	inUseEnterpriseLicenses: z.number(),
	inUseLanCloudSiteLicenses: z.number(),
	inUseNonProductionSiteLicenses: z.number(),
	inUseProfessionalLicenses: z.number(),
	inUseSoftwareEncoders: z.number(),
	lanCloudSiteLicenses: z.number(),
	nonProductionSiteLicenses: z.number(),
	professionalLicenses: z.number(),
	softwareEncoderLicenses: z.number(),
	subtitlesHoursPerMonth: z.number(),
	webBandwidth: z.number()
});
var UserSchema = z.object({
	active: z.boolean(),
	address: z.string().nullable(),
	emailVerified: z.boolean(),
	locked: z.boolean(),
	notes: z.string().nullable(),
	passwordResetRequired: z.boolean(),
	passwordResetToken: z.string().nullable(),
	planId: z.string(),
	planName: z.string(),
	userName: z.string(),
	uuid: z.string(),
	venue: z.boolean()
});
var ResponseSchema = z.object({
	active: z.boolean(),
	additionalAnnualWebDataGb: z.number().optional(),
	additionalConcurrentWebEvents: z.number(),
	additionalVodBandwidthGb: z.number(),
	additionalVodStorageGb: z.number(),
	additionalWebDataGb: z.number(),
	admins: z.array(UserSchema),
	allowed16ChannelAudio: z.boolean(),
	annualWebDataGb: z.number().optional(),
	balance: z.number().nullable(),
	billingYearlyMultiSite: z.boolean().nullable(),
	billingYearlyVod: z.boolean().nullable(),
	billingYearlyWeb: z.boolean().nullable(),
	broadcastSiteLicenses: z.number(),
	customBilling: z.boolean().nullable(),
	dataUsageCapGb: z.number().nullable(),
	demo: z.boolean().nullable(),
	enterpriseSiteLicenses: z.number(),
	fkCustomerType: z.string(),
	lanPlusCloudSiteLicenses: z.number(),
	lastSyncTime: z.string(),
	managedBy: z.string().nullable(),
	managementExpiration: z.string().nullable(),
	masterEcg: z.string().nullable(),
	maxSites: z.number(),
	msa: z.boolean(),
	multisiteStartDate: z.string().nullable(),
	name: z.string(),
	notes: z.string().nullish(),
	numConcurrentTranscodes: z.number(),
	outstanding: z.number().nullable(),
	planId: z.string().nullable(),
	planName: z.string().nullable(),
	professionalSiteLicenses: z.number(),
	regionId: z.string(),
	softwareEncoderLicenses: z.number(),
	status: z.string().nullable(),
	subscriptionDetails: SubscriptionDetailsSchema,
	syncEnabled: z.boolean(),
	usageSummary: UsageSummarySchema,
	uuid: z.string(),
	vodPlanId: z.string().nullable(),
	vodPlanName: z.string().nullable(),
	vodStartDate: z.string().nullable(),
	webBandwidth: z.number(),
	webPlanId: z.string().nullable(),
	webPlanName: z.string().nullable(),
	webStartDate: z.string().nullable(),
	website: z.string().nullable()
});
var parse = parseFactory(ResponseSchema);
//#endregion
export { by_id_exports };

//# sourceMappingURL=by-id.js.map